import makeStyles from '@mui/styles/makeStyles';
import { ArrowRightAlt } from "@mui/icons-material";
import React from "react";
import { NavLink } from "react-router-dom";

interface ShowMoreProps {
  href: string;
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    whiteSpace: "nowrap",
  },
  link: {
    color: theme.palette.grey[100],
    textAlign: "center",
    textDecoration: "none",
  },
}));

export const ShowMore: React.FC<ShowMoreProps> = ({ href }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <NavLink to={href} className={classes.link}>
        <div>Show More</div>
        <ArrowRightAlt />
        {/* TODO: lazy load this icon? or entire component? */}
      </NavLink>
    </div>
  );
};

export default ShowMore;
